"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));
var reselect_1 = require("reselect");
var constants = tslib_1.__importStar(require("@biw/contests-constants"));
var utils = tslib_1.__importStar(require("./utils"));
var programSelectors = tslib_1.__importStar(require("../programs/selectors"));
var clientSelectors = tslib_1.__importStar(require("../client/selectors"));
var translationsSelectors = tslib_1.__importStar(require("../translations/selectors"));
var reducers_1 = require("./reducers");
var api_1 = require("./api");
var progress_model_1 = tslib_1.__importDefault(require("./progress-model"));
var EMPTY_OBJ = {};
var EMPTY_ARRAY = [];
var _getRoot = function (state) { return state[reducers_1.ROOT_KEY] || EMPTY_OBJ; };
var _getViews = reselect_1.createSelector(_getRoot, function (root) { return root.views || EMPTY_OBJ; });
var _getData = function (state) { return state.data || EMPTY_OBJ; };
exports.getPlanData = reselect_1.createSelector(_getRoot, function (root) { return root.paxProgress || EMPTY_OBJ; });
exports.getPlanSets = reselect_1.createSelector(exports.getPlanData, function (planData) { return planData.goalQuestMyPlanVOs || EMPTY_ARRAY; });
exports.getBusySavingPlanSets = reselect_1.createSelector(_getData, function (data) { return get_1.default(data, 'fetching.planSets') || false; });
var _getFetchingErrors = reselect_1.createSelector(_getData, function (data) { return data.fetchingErrors || EMPTY_ARRAY; });
exports.getSavePlanSetsError = reselect_1.createSelector(_getFetchingErrors, function (errs) { return utils.getErrorByType(errs, 'planSets') || false; });
exports.getNoSavedMsg = reselect_1.createSelector(_getRoot, function (root) { return root.noSavedMsg !== false; });
exports.getProgressSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(_getViews, function (views) { return get_1.default(views, "[" + programViewId + "].progress") || EMPTY_OBJ; }); });
exports.getProgramViewProgressData = function (state, programViewId) {
    if (programViewId === void 0) { programViewId = ''; }
    return exports.getProgressSelector(programViewId)(state);
};
exports.getProgressLastViewedSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getProgressSelector(programViewId), _getViews, function (progressData, views) {
    return get_1.default(progressData, 'goal.paxProgressResponse.dataThrough', null) || // selectors
        get_1.default(progressData, 'hierarchyTable.dataThrough', null) || // managers
        get_1.default(progressData, 'detailsTable.dataThrough', null) || // aka other managers
        get_1.default(views, "[" + programViewId + "].lastUpdated", Date.now()); // if the data isn't there
}); });
exports.getProgramViewProgressLastUpdated = function (state, programViewId) {
    if (programViewId === void 0) { programViewId = ''; }
    return exports.getProgressLastViewedSelector(programViewId)(state);
};
exports.getBonusPayoutSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getProgressSelector(programViewId), function (progressData) { return get_1.default(progressData, 'goal.bonusPayout') || EMPTY_OBJ; }); });
function getProgramViewBonusPayout(state, programViewId) {
    return exports.getBonusPayoutSelector(programViewId)(state);
}
exports.getProgramViewBonusPayout = getProgramViewBonusPayout;
exports.getFinalResultsSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getProgressSelector(programViewId), function (progressData) { return progressData.finalResult || EMPTY_OBJ; }); });
function getProgramViewFinalResults(state, programViewId) {
    return exports.getFinalResultsSelector(programViewId)(state);
}
exports.getProgramViewFinalResults = getProgramViewFinalResults;
exports.getGoalSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getProgressSelector(programViewId), function (progressData) { return progressData.goal || EMPTY_OBJ; }); });
function getProgramViewGoal(state, programViewId) {
    return exports.getGoalSelector(programViewId)(state);
}
exports.getProgramViewGoal = getProgramViewGoal;
exports.getEarnedToDateSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getGoalSelector(programViewId), function (goal) { return get_1.default(goal, 'paxProgressResponse.earnedToDate') || 0; }); });
function getProgramViewProgressEarnedToDate(state, programViewId) {
    return exports.getEarnedToDateSelector(programViewId)(state);
}
exports.getProgramViewProgressEarnedToDate = getProgramViewProgressEarnedToDate;
exports.getProgressIsFetchingSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(_getData, function (data) { return get_1.default(data, "fetching." + api_1.getProgramViewProgressType(programViewId)) || false; }); });
function getProgressIsFetching(state, programViewId) {
    return exports.getProgressIsFetchingSelector(programViewId)(state);
}
exports.getProgressIsFetching = getProgressIsFetching;
exports.getRootOrgViewSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getProgressSelector(programViewId), function (progress) {
    var name = get_1.default(progress, 'hierarchyTable.parentOrgUnitName') || reducers_1.DEFAULT_ORG_HIERARCHY[0].name;
    return { name: name, id: name };
}); });
exports.getOrgViewHierarchySelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(_getViews, function (views) { return get_1.default(views, "[" + programViewId + "].orgViewHierarchy") || reducers_1.DEFAULT_ORG_HIERARCHY; }); });
var EMPTY_TABLE_DATA = { detailsTable: null, hierarchyTable: null };
exports.getCurrentTableDataSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(_getViews, exports.getOrgViewHierarchySelector(programViewId), exports.getRootOrgViewSelector(programViewId), function (views, orgHierarchy, rootOrgView) {
    var viewData = views[programViewId] || EMPTY_OBJ;
    var orgUnit = orgHierarchy[orgHierarchy.length - 1];
    if (orgUnit.id === rootOrgView.id) {
        return {
            detailsTable: get_1.default(viewData, 'progress.detailsTable') || null,
            hierarchyTable: get_1.default(viewData, 'progress.hierarchyTable') || null
        };
    }
    return get_1.default(viewData, "orgTables." + orgUnit.id) || EMPTY_TABLE_DATA;
}); });
exports.getProgressModelSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(programSelectors.getProgramSelector(programViewId), function (program) {
    if (!program) {
        return null;
    }
    return progress_model_1.default(program, program.__state);
}); });
exports.getProgress = function (state, programViewId) {
    return exports.getProgressModelSelector(programViewId)(state);
};
exports.getGetString = reselect_1.createSelector(translationsSelectors.getUserBundle, function (bundle) { return function (code, opts) { return translationsSelectors.getStringFromBundle(bundle, code, opts); }; });
exports.getChallengePointBaseEarningDescriptionSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(programSelectors.getProgramSelector(programViewId), exports.getProgressModelSelector(programViewId), exports.getGetString, translationsSelectors.getUserLocale, clientSelectors.getMediaLabel, function (program, progress, getString, locale, mediaLabel) {
    if (!progress || !program) {
        return null;
    }
    return utils.getChallengePointBaseEarningDescription({
        locale: locale,
        getString: getString,
        mediaLabel: mediaLabel,
        baseLevel: progress.baseLevel,
        programType: program.programType,
        goalRoundingMethod: program.goalRoundingMethod,
        goalPayoutTierType: progress.goalPayoutTierType,
        goalLabel: progress.baseGoalLabel
    });
}); });
exports.getChallengePointBaseEarningDescription = function (state, programViewId) {
    return exports.getChallengePointBaseEarningDescriptionSelector(programViewId)(state);
};
exports.getResultCodeSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getProgressModelSelector(programViewId), function (progress) {
    if (!progress) {
        return '';
    }
    return progress.finalResultCode;
}); });
exports.getResultCode = function (state, programViewId) { return exports.getResultCodeSelector(programViewId)(state); };
function getResultType(state, programViewId) {
    if (state === void 0) { state = {}; }
    var progress = exports.getProgress(state, programViewId);
    if (!progress) {
        return '';
    }
    return progress.programResultType;
}
exports.getResultType = getResultType;
exports.getFinalStatusTextSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getProgressModelSelector(programViewId), exports.getGetString, clientSelectors.getMediaLabel, function (progress, getString, mediaLabel) {
    if (!progress || !progress.finalStatus) {
        return null;
    }
    var replaceOpts = { mediaLabel: mediaLabel };
    var _a = progress.finalStatus, message = _a.message, submessage = _a.submessage, footer = _a.footer;
    return {
        message: {
            text: getString(message.key, replaceOpts),
            status: message.cssClass
        },
        submessage: {
            text: getString(submessage.key, replaceOpts),
            status: submessage.cssClass
        },
        footer: {
            text: getString(footer.key, replaceOpts),
            status: footer.cssClass
        }
    };
}); });
exports.getFinalStatusText = function (state, programViewId) { return exports.getFinalStatusTextSelector(programViewId)(state); };
exports.getPayoutBonusMessageSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(programSelectors.getProgramSelector(programViewId), exports.getProgressModelSelector(programViewId), exports.getGetString, translationsSelectors.getUserLocale, clientSelectors.getMediaLabel, exports.getFinalResultsSelector(programViewId), function (program, progress, getString, locale, mediaLabel, finalResult) {
    if (!progress || !program || !Object.keys(progress.bonusPayout).length) {
        return null;
    }
    var getBonusProps = {
        bonusPayout: progress.bonusPayout,
        getString: getString,
        locale: locale,
        mediaLabel: mediaLabel,
        bonusPoints: finalResult.totalBonusPoints,
        bonusPrecision: program.bonusPrecision,
        bonusRoundingMethod: program.bonusRoundingMethod
    };
    if (progress.bonusPayout.payoutStructureType === constants.PT__FIXED) {
        return getString('common.bonus.fixedLabelText', utils.getBonusReplaceOptions(getBonusProps));
    }
    else {
        return utils.getBonusMessage(getBonusProps);
    }
}); });
exports.getPayoutBonusMessage = function (state, programViewId) {
    return exports.getPayoutBonusMessageSelector(programViewId)(state);
};
exports.getSelectedGoalLevelFixedRateMessageSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(programSelectors.getProgramSelector(programViewId), exports.getProgressModelSelector(programViewId), exports.getGetString, translationsSelectors.getUserLocale, clientSelectors.getMediaLabel, function (program, progress, getString, locale, mediaLabel) {
    if (!progress || !program || !progress.isFixedRatePayout) {
        return null;
    }
    var selectedGoal = progress.goalSelection;
    return utils.getFixedPlusRatePayoutMessage({
        goalPayoutTierType: progress.goalPayoutTierType,
        getString: getString,
        locale: locale,
        mediaLabel: mediaLabel,
        goalLabel: progress.baseGoalLabel,
        goalRoundingMethod: program.goalRoundingMethod,
        incrementQuantity: selectedGoal.incrementQuantity,
        goalAchieveAmount: selectedGoal.goalAchieveAmount,
        incrementAward: selectedGoal.incrementAward,
        maxPoints: selectedGoal.maxPoints
    });
}); });
exports.getSelectedGoalLevelFixedRateMessage = function (state, programViewId) {
    return exports.getSelectedGoalLevelFixedRateMessageSelector(programViewId)(state);
};
exports.getGoalLevelFixedRateMessageArraySelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(programSelectors.getProgramSelector(programViewId), exports.getProgressModelSelector(programViewId), exports.getGetString, translationsSelectors.getUserLocale, clientSelectors.getMediaLabel, function (program, progress, getString, locale, mediaLabel) {
    if (!progress || !program || !progress.isFixedRatePayout) {
        return EMPTY_ARRAY;
    }
    return utils.getFixedPlusRatePayoutArray({
        goalPayoutTierType: progress.goalPayoutTierType,
        getString: getString,
        locale: locale,
        mediaLabel: mediaLabel,
        goalLabel: progress.baseGoalLabel,
        goalRoundingMethod: program.goalRoundingMethod,
        goalLevels: progress.goalLevels
    });
}); });
exports.getGoalLevelFixedRateMessageArray = function (state, programViewId) {
    return exports.getGoalLevelFixedRateMessageArraySelector(programViewId)(state);
};
exports.getBonusProgressLabelSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(exports.getProgressModelSelector(programViewId), translationsSelectors.getUserLocale, function (progress, locale) {
    if (!progress || !progress.bonusPayoutProgress) {
        return '';
    }
    var bonusPayoutLabel = progress.bonusPayoutProgress.goalLabelProps;
    return utils.getLabelString(bonusPayoutLabel, bonusPayoutLabel.amount, bonusPayoutLabel.precision, bonusPayoutLabel.rounding, locale);
}); });
exports.getBonusProgressLabel = function (state, programViewId) {
    return exports.getBonusProgressLabelSelector(programViewId)(state);
};
//# sourceMappingURL=selectors.js.map